export default __webpack_public_path__ + "static/media/ubr5.fbaa9564.jpeg";